import { RadioGroup } from '#components/patterns/forms/radio/index.ts';
import { RadioCard } from '#components/patterns/forms/radio/RadioCard.tsx';
import { INSTALL_METHODS, type LinuxInstallMethod } from './package-install.ts';
import styles from './InstallMethodPicker.module.css';

type Props = {
  value: LinuxInstallMethod;
  onChange: (method: LinuxInstallMethod) => void;
};

/**
 * The Linux install-method cards. Rendered in both the expanded and condensed layouts, so a user
 * who condensed the commands can still switch off the default APT path.
 */
export function InstallMethodPicker({ value, onChange }: Props) {
  return (
    <RadioGroup
      name="linux-install-method"
      value={value}
      onChange={(e) => onChange(e.currentTarget.value as LinuxInstallMethod)}
    >
      {/* RadioGroup renders no element of its own; name the group here so screen readers
          announce what the four radios govern. */}
      <div className={styles.InstallMethodPicker_methods} role="radiogroup" aria-label="Install method">
        {INSTALL_METHODS.map((method) => (
          <RadioCard key={method.key} value={method.key} className={styles.InstallMethodPicker_methodCard}>
            <span className={styles.InstallMethodPicker_methodLabel}>
              <span className="h6">{method.title}</span>
              <span className="p-sm color-lowlight">{method.description}</span>
            </span>
          </RadioCard>
        ))}
      </div>
    </RadioGroup>
  );
}
